module.exports = __webpack_public_path__ + "img/56_55.62d41017.png";